import { useRouter } from "next/router"

export function useOrderModeFromUrl() {
  const router = useRouter()
  const orderMode = router.query.orderMode as "pickup" | "delivery"
  return orderMode
}
